import React from 'react';
import { Grid } from "@material-ui/core";
import { isMobile, isTablet } from "../filters/filter_constants_and_helpers.jsx.erb";

export const getHeightOfStub = () => {
    if (isMobile() && !isTablet()) { // mobile
        return '135px';
    } else if ((isTablet() && window.screen.width > 840) || !isTablet()) { // desktop and iPad pro handle in the same way
        return '178px';
    } else { // tablet
        return '245px';
    }
};

const Loading = () => {
    const loadingItems = (isTablet() && window.screen.width > 840) || (!isTablet() && !isMobile()) ? [1, 2, 3, 4] : [1, 2];

    return (
        <Grid
            container
            spacing={isMobile() && !isTablet() ? 2 : 4}
        >
            {
                loadingItems.map((e) => (
                    <Grid className="deal-preview-loader" key={e} item sm={6} xs={6} md={3} lg={3} >
                        <div className="stub image-stub" style={{ height: getHeightOfStub() }}></div>
                        <div className="stub text-first-stub"></div>
                        <div className="stub text-second-stub"></div>
                    </Grid>
                ))
            }
        </Grid>
    )
};

export default Loading;
